<template>
<div class="limiter">
  <div class="container-login">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="12" md="9" lg="9">
          <v-card class="login" flat style="border-radius: 10px;padding: 10px;" color="#263238">
            <span class="login-title">
              <img src="../../assets/LogoBrancoHorizontal.png" width="250px">
            </span>
            <v-card-text style="padding: 0px">
              <v-container fluid grid-list-md>
                <v-layout row wrap>
                  <v-flex xs12 sm12 lg6>
                    <p style="margin-bottom: 0px;color:white">Informe seu CPF:</p>
                    <v-text-field dark placeholder="CPF" color="white" outlined v-mask="mask" dense hide-details required v-validate="'required|cpf'" :error-messages="errors.collect('cpf')" data-vv-name="cpf" type="tel" v-model="inscricao.cpf"></v-text-field>
                    <br>
                  </v-flex>
                  <v-flex xs12 sm12 lg6>
                    <p style="margin-bottom: 0px;color:white">Informe sua data de nascimento:</p>
                    <v-text-field dark placeholder="Data de Nascimento" color="white" outlined v-mask="'##/##/####'" dense hide-details required type="tel" v-model="dataNascimento"></v-text-field>
                    <br>
                  </v-flex>
                  <v-flex v-if="!cpfLocalizado" xs12 sm12 lg12>
                    <v-btn dark block depressed color="#01579B" style="border-radius: 7px;" large @click="verificaCpf">Verificar</v-btn>
                  </v-flex>
                  <v-flex v-if="associacoesEvento.length > 0" xs12 sm12 md12 lg12>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;color:white">Bem-Vindo(a) <span style="font-weight: bold;">{{vigilanteName}}</span> </p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                    <p style="color: white">Inscrições realizadas:</p>
                    </v-flex>
                    <v-layout row wrap v-for="evento in associacoesEvento" :key="`${evento.nome}`">
                      <v-flex xs12 sm12 md6 lg6>
                        <v-text-field style="margin-bottom: -30px" dark outlined disabled dense label="Evento" v-model="evento.nomeEvento"></v-text-field>
                      </v-flex>
                      <v-flex v-if="evento.status == 'APROVADO'" xs12 sm12 md2 lg2 style="margin-bottom: -10px; ">
                        <v-alert dense dark color="success" type="success">{{evento.status}}</v-alert>
                      </v-flex>
                      <v-flex v-if="evento.status == 'RECUSADO'" xs12 sm12 md4 lg4 style="margin-bottom: -10px">
                        <v-alert dense dark color="error" type="error">{{evento.status}}</v-alert>
                      </v-flex>
                      <v-flex v-if="evento.status == 'EM ANÁLISE'" xs12 sm12 md4 lg4 style="margin-bottom: -10px">
                        <v-alert dense dark color="warning" type="warning">{{evento.status}}</v-alert>
                      </v-flex>
                      <v-flex xs12 sm12 md2 lg2 style="margin-bottom: 10px">
                        <v-btn dark block color="#1565C0" large @click="openDetalhes(evento)">Detalhes</v-btn>
                      </v-flex>
                      <v-flex xs12 sm12 md2 lg2 style="margin-bottom: 10px">
                        <v-btn dark block color="red" large @click="deletaAssociacao(evento)">Desistir</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex v-if="cpfLocalizado" xs12 sm12 lg12>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;color:white">Selecione o(s) evento(s) que você deseja participar:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-select multiple outlined dense dark v-model="inscricao.eventos" :items="eventos" item-disabled="disabled" item-text="nome" item-value="id" color="white" @input="verificaEventos()"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 md12 lg12>
                      <v-checkbox v-model="aceitaContrato" dark>
                        <span slot="label">Estou ciente que ao informar o CPF, autorizo à empresa responsável pelo evento a avaliar meu cadastro e me coloco a disposição para trabalhar nos eventos selecionados acima.</span>
                      </v-checkbox>
                    </v-flex>
                  </v-flex>
                  <!-- <v-flex xs10 sm10 lg12>
                    <qrcode-vue :value="'12456'" :size="size" level="H"></qrcode-vue>
                  </v-flex> -->
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions v-if="cpfLocalizado" style="padding: 0px">
              <v-container fluid grid-list-md>
                <v-layout row wrap justify-center>
                  <v-flex xs12 sm12 lg12>
                    <v-btn dark depressed block color="#01579B" style="border-radius: 7px;" :disabled="isLoading" large @click="associaVigilante">Confirmar</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <br>
      <div class="login-title">
        <a href="https://www.intelitetecnologia.com.br/" target="_blank">
          <img src="../../assets/LogoBrancoHorizontal.png" width="130px">
        </a>
      </div>

      <v-dialog v-model="mensagemFinal" persistent max-width="600px">
        <v-card style="border-radius: 10px;">
          <v-card-text style="text-align: justify;padding:0 24px 0;">
            <v-container>
              <v-row align="center" justify="center">
                <v-col cols="12" sm="6" md="12" style="padding: 2px;" align="center">
                  <!-- <p class="texto">Sucesso na inscricao!</p> -->
                </v-col>
                <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                  <p class="texto" style="color:#EF6C00"></p>
                </v-col>
              </v-row>
              <div v-for="evento in eventosAssociados" :key="`${evento.nome}`">
                <div v-if="evento.status == 'APROVADO'">
                  <p style="color: green; text-align: center; font-size: 17px;">Inscrição realizada para o evento {{evento.nomeEvento}}!</p>
                </div>
                <div v-else-if="evento.status == 'RECUSADO'">
                  <p style="color: red; text-align: center; font-size: 17px;">Inscrição já realizada anteriormente para o evento {{evento.nomeEvento}}.</p>
                </div>
                <div v-else-if="evento.status == 'EXCEDIDO'">
                  <p style="color: red; text-align: center; font-size: 17px;">Inscrição não realizada para o evento {{evento.nomeEvento}}. Limite de vagas excedido.</p>
                </div>
              </div>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn style="border-radius: 7px;" dark depressed block color="#7b4f44" @click="recarregarPagina">fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog detalhes -->
      <v-dialog v-model="details" persistent max-width="600px">
        <v-card style="border-radius: 10px;">
          <v-card-text style="text-align: justify;padding:0 24px 0;">
            <v-container>
              <v-row align="center" justify="center">
                <v-col cols="12" sm="6" md="12" style="padding: 2px;" align="center">
                </v-col>
                <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                  <p class="texto" style="color:#1565C0">Detalhes do Evento</p>
                </v-col>
                <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                  <p class="texto" v-if="detailsEvent.nome" style="color:#1565C0">Evento: {{detailsEvent.nome}}</p>
                  <p class="texto" v-if="qualificacao" style="color:#1565C0">Classificação: {{qualificacao}}</p>
                  <p class="texto" v-if="qualificacao=='APOIO'" style="color:#1565C0">Remuneração: R${{detailsEvent.vlApoio}}</p>
                  <p class="texto" v-if="qualificacao=='VIGILANTE BÁSICO'" style="color:#1565C0">Remuneração: R${{detailsEvent.vlBasico}}</p>
                  <p class="texto" v-if="qualificacao=='VIGILANTE DE GRANDES EVENTO'" style="color:#1565C0">Remuneração: R${{detailsEvent.vlGrandesEventos}}</p>
                  <p class="texto" v-if="detailsEvent.hrInicio" style="color:#1565C0">Hora Início: {{detailsEvent.hrInicio}}</p>
                  <p class="texto" v-if="detailsEvent.hrApresentacao" style="color:#1565C0">Hora Apresentação: {{detailsEvent.hrApresentacao}}</p>
                  <p class="texto" v-if="detailsEvent.hrFim" style="color:#1565C0">Hora Fim: {{detailsEvent.hrFim}}</p>
                  <p class="texto" v-if="detailsEvent.endereco" style="color:#1565C0">Endereço: <a :href="detailsEvent.endereco" target="_blank">Clique aqui para ver a localização</a></p>
                  <p class="texto" v-if="detailsEvent.traje" style="color:#1565C0">Traje: {{detailsEvent.traje}}</p>
                  <p class="texto" v-if="detailsEvent.alimentacao" style="color:#1565C0">Alimentação: {{detailsEvent.alimentacao}}</p>
                </v-col>
              </v-row>

            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn style="border-radius: 7px;" dark depressed block color="#1565C0" @click="details=false">fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-container>
  </div>
  <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage">
  </loading>
  <Snackbar ref=chamaSnackbar />
</div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../../componentes/snackbar.vue'
  import { mapState } from 'vuex'
  import moment from 'moment'
  import axios from 'axios'

  export default {
    components: { Snackbar, Loading },
    name: 'Auth',

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
    }),

    data: function () {
      return {
        mask: "###.###.###-##",
        user: {},
        aceitaContrato: false,
        inscricao: {
          cpf: '',
          eventos: [],
        },
        inscricaoDefault: {
          cpf: '',
          eventos: [],
        },
        mensagemFinal: false,
        eventos: [],
        isLoading: false,
        fullPage: true,
        eventosAssociados: [],
        cpfLocalizado: false,
        dataNascimento: '',
        associacoesEvento: [],
        vigilanteId: '',
        vigilanteName: '',
        detailsEvent: '',
        qualificacao: '',
        details: false
      }
      
    },

    mounted: function () {
      //this.carregaDados()
      this.$validator.localize('pt', this.dictionary)
    },

    methods: {
      async carregaDados(qualificacao) {
        this.eventos = []
        this.inscricao.eventos = []
        this.isLoading = true
        await axios.get(`${baseApiUrl}Eventos?filter={"where":{"and":[{"empresaId":"61a63c2c36a415043173a58d"},{"ativo":"true"},{"qualificacoes":{"inq":["${qualificacao}"]}}]}, "order":"inicio ASC"}`)
        .then(res => {
          for (var key in res.data) {
            if (res.data.hasOwnProperty(key)) {
              if (moment(this.formatDateHora(res.data[key].fim), 'DD/MM/YYYY HH:mm:ss', true).format() >= moment().format()) {
                this.eventos.push(res.data[key])
                this.eventoId = res.data[key].id
              }
            }
          }
          this.eventos = this.eventos.sort(this.compare)
          this.cpfLocalizado = true
          this.isLoading = false
        })
      },

      async associaVigilante() {
        if ((this.inscricao.cpf == '') || (this.inscricao.eventos.length == 0)) {
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "Para continuar, informe o CPF e selecione um evento!", "ATENÇÃO")
        } else {
          if (!this.aceitaContrato) {
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825", "Para continuar, marque o termo de ciência!", "ATENÇÃO")
          } else {
            this.isLoading = true
            try {
              await axios.post(`${baseApiUrl}AssociacoesEvento/solicitaAssociacao`, this.inscricao).then(res => {
                if (res.data) {
                  this.eventosAssociados = res.data
                  this.mensagemFinal = true
                  this.isLoading = false
                }
              })
            } catch (error) {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350", "Problema encontrado ao realizar inscrição. " + error.response.data.error.message + ".", "ERRO")
            }
          }
        }
      },

      async verificaCpf() {
        var vm = this;
        if (this.inscricao.cpf == '' || this.dataNascimento == '') {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Para continuar, informe o CPF e a data de nascimento!", "ATENÇÃO")
        } else {
          try {
            this.isLoading = true
            await axios.get(`${baseApiUrl}Vigilantes?filter={"where":{"and":[{"cpf":"${this.inscricao.cpf}"},{"dataNascimento":"${this.dataNascimento}"}]}, "fields":{"qualificacao":true,"situacao":true,"dataNascimento":true,"id":true}}`).then(response => {
            //await axios.get(`${baseApiUrl}Vigilantes?filter={"where":{"and":[{"cpf":"${this.inscricao.cpf}"}]}, "fields":{"qualificacao":true,"situacao":true,"dataNascimento":true,"id":true, "nome": true}}`).then(response => {
              if (response.data) {
                if (response.data[0].situacao == 'ATIVO') {
                  this.vigilanteId = response.data[0].id
                  this.vigilanteName = response.data[0].nome
                  this.qualificacao = response.data[0].qualificacao
                  this.verificaAssociacoes()
                  this.carregaDados(response.data[0].qualificacao)
                } else {
                  this.isLoading = false
                  vm.$refs.chamaSnackbar.snack("#F9A825", "Vigilante com situação não ativa. Entre em contato com a administração.", "ATENÇÃO")
                }
              }
            })
          } catch (error) {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema encontrado ao consultar CPF e data de nascimento", "DESCULPE!")
          }
        }
      },

      async verificaAssociacoes() {
        try {
          await axios.post(`${baseApiUrl}AssociacoesEvento/resultadoConvocacao`, {"vigilanteId": this.vigilanteId}).then(response => {
            if (response.data) {
              this.associacoesEvento = response.data
              this.isLoading = false
            }
          })
        } catch (error) {
          this.isLoading = false
        }
      },

      formatDateHora(date) {
        if (!date) return null

        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },

      recarregarPagina() {
        window.location.reload()
      },

      async deletaAssociacao(evento) {
        var r = confirm('Deseja realmente desistir de ser voluntário ao evento ' + evento.nomeEvento + '?')
        if (r == true) {
          this.isLoading = true
          await axios.delete(`${baseApiUrl}AssociacoesEvento/${evento.id}`)
            .then(() => {
              var vm = this
              vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
              this.verificaAssociacoes()
            }).catch(() => {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao desistir do evento. Tente novamente", "DESCULPE")
            })
        }
      },

      async openDetalhes(evento) {
        await axios.get(`${baseApiUrl}Eventos?filter={"where":{"and":[{"empresaId":"61a63c2c36a415043173a58d"},{"ativo":"true"},{"nome":"${evento.nomeEvento}"}]}}`)
        .then(res => {
          if (res.data != '') {
            this.detailsEvent = res.data[0]
            this.details = true
          }
        })        
      },

      verificaEventos() {
        if (this.inscricao.eventos.length > 0) {
          for (let i = 0; i < this.eventos.length; i++) {
            this.eventos[i].disabled = false
          }
          for (let i = 0; i < this.inscricao.eventos.length; i++) {
            for (let j = 0; j < this.eventos.length; j++) {
              if (this.inscricao.eventos[i] == this.eventos[j].id) {
                for (let k = 0; k < this.eventos.length; k++) {
                  if (this.eventos[j].id != this.eventos[k].id) {
                    if (this.eventos[j].inicio.substring(0, 10) == this.eventos[k].inicio.substring(0, 10)) {
                      this.eventos[k].disabled = true
                      break
                    }
                  } else {
                    this.eventos[k].disabled = false
                  }
                }
              }
            }
          }
        } else {
          for (let i = 0; i < this.eventos.length; i++) {
            this.eventos[i].disabled = false
          }
        }
      },
    }
  }
</script>

<style scoped>
  /* LOGIN */

  .limiter {
    width: 100%;
    margin: 0 auto;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: linear-gradient(to right, #455A64, #37474F);
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;
  }

  .texto {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .login {
    min-width: 80%;
    border-radius: 15px;
    background-color: #fff;
    opacity: 0.9;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .login-title {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center
  }
</style>
